module.exports = __webpack_public_path__ + "img/instagramestory3-1.b9590e79.jpg";